/* 🤖 this file was generated by svg-to-ts */
export const matIconCurrencyYuan: {
  name: 'currency-yuan';
  data: string;
} = {
  name: 'currency-yuan',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13.28 12H18v2h-5v7h-2v-7H6v-2h4.72L5 3h2.37L12 10.29 16.63 3H19z"/></svg>`
};
